import React, { useEffect, useRef, useState } from "react";
import { Box, Modal } from "@mui/material";
import { useForm } from "react-hook-form";
import { SlClose } from "react-icons/sl";
import Swal from "sweetalert2";

function QuoteModal({ open, setOpen, CloseModal, subject: subjectProp = "" }) {
  const [index, setIndex] = useState(0);
  const [view, setView] = useState(false);
  const [verified, setVerified] = useState(false);
  const [reError, setReError] = useState(false);
  const [num, setNum] = useState(0);
  const [num1, setNum1] = useState(0);
  const [sum, setSum] = useState("");
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    setValue("subject", subjectProp); // Set subject from props
  }, [subjectProp, setValue]);

  useEffect(() => {
    const timer = setTimeout(() => setView(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (view) {
      setNum(randomNumberInRange(1, 9));
      setNum1(randomNumberInRange(1, 9));
    }
  }, [view]);

  //   useEffect(() => {
  //     const intervalId = setInterval(() => setIndex((prev) => prev + 1), 3000);
  //     return () => clearInterval(intervalId);
  //   }, []);
  useEffect(() => {
    const intervalId = setInterval(
      () => setIndex((index) => index + 1),
      3000 // every 3 seconds
    );
    return () => clearTimeout(intervalId);
  }, [index]);

  useEffect(() => {
    if (verified) {
      const timer = setTimeout(() => {
        setVerified(false);
        setNum(randomNumberInRange(1, 9));
        setNum1(randomNumberInRange(1, 9));
        setSum("");
      }, 30000);
      return () => clearTimeout(timer);
    }
  }, [verified]);

  const randomNumberInRange = (min, max) =>
    Math.floor(Math.random() * (max - min + 1)) + min;

  const handleVerify = () => {
    if (num + num1 === parseInt(sum)) {
      setVerified(true);
      setSum("");
      setReError(false);
    } else {
      setSum("");
      setReError(true);
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://vidhaninfotech.com/smtptester/mailsend.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      if (response.status === 200) {
        setOpen(false)
        Swal.fire({
          title: "Good job!",
          text: "We received your request, We will respond soon!",
          icon: "success",
        });
        setLoading(false);
      } else {  
        setOpen(false)
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        setLoading(false);
      }
    } catch (error) {
      setOpen(false)
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
      setLoading(false);
      console.log(error);
      
    }
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Box
        sx={{
          p: 3,
          bgcolor: "white",
          width: "fit-content",
          mx: "auto",
          mt: "20vh",
          borderRadius: 2,
          outline: 0,
          maxWidth: "50%",
        }}
      >
        <div className="d-flex align-items-center justify-content-between mb-4 pb-2 border-bottom">
          <h5 className="m-0">{subjectProp ? subjectProp : "Contact Us"}</h5>
          <button
            type="button"
            className="noBtn"
            onClick={CloseModal}
            style={{ lineHeight: 0 }}
          >
            <SlClose />
          </button>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="getintouchform">
          <div className="row" style={{ gap: "20px 0" }}>
            <div className="col-md-6">
              <input
                className="form-control"
                type="text"
                placeholder="Your Name"
                {...register("name", { required: "Name is required" })}
              />
              {errors.name && (
                <span className="error_msg">{errors.name.message}</span>
              )}
            </div>
            <div className="col-md-6">
              <input
                className="form-control"
                type="email"
                placeholder="Your Email"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Enter a valid email",
                  },
                })}
              />
              {errors.email && (
                <span className="error_msg">{errors.email.message}</span>
              )}
            </div>
            <div className="col-md-12">
              <input
                className="form-control"
                type="text"
                placeholder="Subject"
                {...register("subject", { required: "Subject is required" })}
              />
              {errors.subject && (
                <span className="error_msg">{errors.subject.message}</span>
              )}
            </div>
            <div className="col-md-12">
              <textarea
                className="form-control"
                rows={5}
                placeholder="Message"
                {...register("message", { required: "Message is required" })}
              />
              {errors.message && (
                <span className="error_msg">{errors.message.message}</span>
              )}
            </div>
            <div className="col-md-6">
              <div className="recaptcha_container d-flex gap-3">
                <p className="my-auto" style={{ flex: "none" }}>
                  {num} + {num1} =
                </p>
                <input
                  className="form-control"
                  type="text"
                  ref={inputRef}
                  name="inputValue"
                  disabled={verified}
                  onChange={(e) => setSum(e.target.value)}
                  maxLength="3"
                  placeholder="0"
                  value={sum}
                />
                <button
                  className="theme_btn px-4 py-1"
                  style={{ minWidth: "fit-content" }}
                  type="button"
                  onClick={handleVerify}
                  disabled={!sum}
                >
                  <span>Verify</span>
                </button>
              </div>
              {reError && (
                <span className="error_msg">You have entered wrong value</span>
              )}
            </div>
            <div className="col-md-12">
              <div className="justify-content-center d-flex align-items-center flex-column gap-2">
                <input
                  type="submit"
                  className={`px-4 py-2 ${verified ? "theme_btn" : "closebtn"}`}
                  disabled={verified ? false : true}
                  value={loading ? "Loading..." : "SEND A MESSAGE"}
                />
                <p className="m-0">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://wa.me/7862835714"
                  >
                    Directly Connect To WhatsApp: <b>+91 7862 835 714</b>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </form>
      </Box>
    </Modal>
  );
}

export default React.memo(QuoteModal);
